import styled, { css } from "styled-components";

const MapControlButton = styled.button.attrs({})`
  box-sizing: border-box;
  height: 45px;
  width: auto;
  border: 4px solid rgba(129,51,78, 0.29);
  background-color: #ffffff;
  border-radius: 35px;
  padding: 15px;
  ${props =>
    props.icon &&
    css`
      background-image: url(${props.icon});
      background-position: 15px center;
      background-repeat: no-repeat;
      background-size: 45px;
      padding-left: 45px;
    `}
  ${props =>
    props.large &&
    css`
      padding-left: 65px;
      height: 70px;
      width: auto;
    `};
`;

export default MapControlButton;
